import EmptyState from '@/app/(main)/_components/empty-state/empty-state';

export default function PartnerNotFound() {
  return (
    <EmptyState
      title="Clínica não encontrada"
      description="Esta clínica não está disponível em nossa plataforma. Confira outras opções disponíveis:"
      button={{
        label: 'Ver rede de atendimento',
        href: '/rede-de-atendimento/',
      }}
    />
  );
}
